import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import TrackerReport from 'app/models/tracker_report';

export default ReportsBase.extend({
  model: TrackerReport,
  url: appUrl('reports/tracker'),
});



// WEBPACK FOOTER //
// ./app/collections/tracker_reports.js